import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'card-header', // tslint:disable-line
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardHeaderComponent {}
